import React, { useState, useEffect } from 'react';
import { Layout } from 'antd';
import get from 'lodash/get';

import FilterBar from './FilterBar';
import TableTransactions from './TableTransactions';
import { apiGetTransaction } from 'APIService/transactionService';
import useAPILoading from 'hooks/useAPILoading';

const { Content } = Layout;

const getTransactionParams = ({ filter, sort, pagination = {} } = {}) => {
  const { dateRange, ...othersFilter } = filter;
  if (dateRange) {
    othersFilter.fromDate = dateRange[0];
    othersFilter.toDate = dateRange[1];
  }

  let formattedSort;
  if (sort && sort.order) {
    formattedSort = {
      field: sort.field,
      order: sort.order === 'descend' ? 'desc' : 'asc',
    };
  }
  const output = {
    filter: othersFilter,
    pageSize: pagination.pageSize,
    page: pagination.current,
    sort: formattedSort,
  };
  return output;
};

const PageTransactionsHistory = (props) => {
  const [getTransaction, loading] = useAPILoading(apiGetTransaction);

  const [resData, setResData] = useState();
  const [params, setParams] = useState({
    pagination: {
      current: 1,
      pageSize: 10,
    },
    filter: {},
    sort: {},
  });

  useEffect(() => {
    getTransaction(getTransactionParams(params)).then(({ data }) => {
      setResData(data);
    });
  }, [params]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleTableChange = (pagination, filters, sort) => {
    setParams({ ...params, pagination, sort });
  };

  const handleFilterChange = (filter) => {
    let { pagination } = params;
    pagination = { ...pagination, current: 1 };
    //set page to 1 when change filter

    setParams({ ...params, filter, pagination });
  };

  const { filter, pagination } = params;

  return (
    <Content
      style={{
        padding: 20,
        background: 'white',
        borderTop: '1px black solid',
      }}>
      <FilterBar
        value={filter}
        onChange={handleFilterChange}
        loading={loading}
      />
      <TableTransactions
        dataSource={get(resData, 'data')}
        pagination={{ ...pagination, total: get(resData, 'total') }}
        loading={loading}
        onChange={handleTableChange}
      />
    </Content>
  );
};

export default PageTransactionsHistory;
